import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AuthStore, OpenIdUserData } from '@workspace/ng-data-access';
import { ObfuscateEmailPipe } from '../../../../pipes/obfuscate-email.pipe';

@Component({
  selector: 'aura-impersonate-banner',
  templateUrl: './impersonate-banner.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    ObfuscateEmailPipe,
  ],
})
export class AuraImpersonateBannerComponent {
  private readonly authStore = inject(AuthStore);

  public isImpersonated = signal<boolean>(this.authStore.isImpersonated());
  public openIdUserData = signal<OpenIdUserData | null>(this.authStore.openIdUserData() ?? null);

  closeImpersonate() {
    this.authStore.closeImpersonate().subscribe();
  }
}
